import { TFilterTypes, TSortState } from './types'
import SearchIcon from '@mui/icons-material/Search'
import { FilterVariant, TableColumn } from 'types'
import EqualsIcon from 'assets/svgComponents/EqualsIcon'
import NotEqualsIcon from 'assets/svgComponents/NotEqualsIcon'
import LessThanIcon from 'assets/svgComponents/LessThanIcon'
import GreaterThanIcon from 'assets/svgComponents/GreaterThanIcon'
import BetweenIcon from 'assets/svgComponents/BetweenIcon'
import GreaterThanOrEqual from 'assets/svgComponents/GreaterThanOrEqual'
import LessThenOrEqualsIcon from 'assets/svgComponents/LessThenOrEqual'
import {
  DateNumberFunctions,
  SelectFunctions,
  TextFunctions,
} from './constants'
import StartsWithIcon from 'assets/svgComponents/StartsWithIcon'
import DoesNotContainIcon from 'assets/svgComponents/DoesNotContainIcon'
import ContainsIcon from 'assets/svgComponents/ContainsIcon'
import EndsWithIcon from 'assets/svgComponents/EndsWithIcon'

export function handleFilterIcon(filterType: TFilterTypes) {
  switch (filterType) {
    case 'eq':
      return <EqualsIcon width={20} />
    case 'neq':
      return <NotEqualsIcon width={20} />
    case 'gt':
      return <GreaterThanIcon width={20} />
    case 'lt':
      return <LessThanIcon width={20} />
    case 'lte':
      return <LessThenOrEqualsIcon width={20} />
    case 'gte':
      return <GreaterThanOrEqual width={20} />
    case 'between':
      return <BetweenIcon width={20} />
    case 'starts_with':
      return <StartsWithIcon />
    case 'ends_with':
      return <EndsWithIcon />
    case 'contains':
      return <ContainsIcon />
    case 'not_contains':
      return <DoesNotContainIcon />

    case 'reset':
      return <SearchIcon />
    default:
      return <SearchIcon />
  }
}

export const handleFilterList = (filterVariant: FilterVariant) => {
  if (filterVariant === 'string') return TextFunctions
  if (filterVariant === 'select') return SelectFunctions
  return DateNumberFunctions
}

export const handleIsFilter = (columns: TableColumn[]) =>
  columns?.some((column) => column?.filterParams?.filterVariant)

export const createFilterState = (columns: TableColumn[]) => {
  const keys = columns
    .map((item) => item.id)
    .filter((item) => item !== 'actions')

  return keys.reduce((acc, item) => {
    const column = columns.find((col) => col.id === item)

    acc[item] = {
      value: column?.filterParams?.defaultFilterValue || '',
      filterType:
        column?.filterParams?.defaultOperatorValue ||
        (column?.filterParams?.filterVariant === 'string' ? 'contains' : 'eq'),
      filterField: column?.filterParams?.filterField || item,
    }

    return acc
  }, {})
}

export const createSortState = (columns: TableColumn[]): TSortState => {
  const keys = columns
    .map((item) => item.id)
    .filter((item) => item !== 'actions')

  return keys.reduce((acc, item) => {
    acc[item] = ''
    return acc
  }, {})
}

export const NumberRegexp = /^[0-9\b]+$/
